"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humazineDuration = exports.DEFAULT_GERMAN_DATETIME_FORMAT = exports.ONE_WEEK = exports.ONE_DAY = exports.ONE_HOUR = exports.ONE_MINUTE = void 0;
exports.ONE_MINUTE = 1000 * 60;
exports.ONE_HOUR = exports.ONE_MINUTE * 60;
exports.ONE_DAY = exports.ONE_HOUR * 24;
exports.ONE_WEEK = exports.ONE_DAY * 7;
exports.DEFAULT_GERMAN_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
// eslint-disable-next-line complexity
function humazineDuration(durationInMs, options = {}) {
    if (options.relativeToNow === true)
        durationInMs -= Date.now();
    if (options.negate === true)
        durationInMs *= -1;
    if (!options.showSeconds)
        options.showSeconds = false;
    if (!options.shortFormat)
        options.shortFormat = false;
    const result = {};
    const s = {
        year: 31536000000,
        month: 2419200000,
        week: 604800000,
        day: 86400000,
        hour: 3600000,
        minute: 60000,
        second: 1000
    };
    if (durationInMs > 0)
        Object.keys(s).forEach((key) => {
            result[key] = Math.floor(durationInMs / s[key]);
            durationInMs -= result[key] * s[key];
        });
    else
        Object.keys(s).forEach((key) => {
            result[key] = Math.ceil(durationInMs / s[key]);
            durationInMs -= result[key] * s[key];
        });
    const str = [];
    if (!options.shortFormat) {
        if (result.month && result.month > 0)
            str.push(`${result.month} Monat${result.month === 1 ? "" : "e"}`);
        if (result.week && result.week > 0)
            str.push(`${result.week} Woche${result.week === 1 ? "" : "n"}`);
        if (result.day && result.day > 0)
            str.push(`${result.day} Tag${result.day === 1 ? "" : "e"}`);
        if (result.hour && result.hour > 0)
            str.push(`${result.hour} Stunde${result.hour === 1 ? "" : "n"}`);
        if (result.minute && result.minute > 0)
            str.push(`${result.minute} Minute${result.minute === 1 ? "" : "n"}`);
        if (options.showSeconds && result.second && result.second > 0)
            str.push(`${result.second} Sekunde${result.second === 1 ? "" : "n"}`);
        if (str.length === 0)
            return "-";
        return str.join(", ");
    }
    else {
        if (result.month && result.month > 0)
            str.push(`${result.month}M`);
        if (result.week && result.week > 0)
            str.push(`${result.week}W`);
        if (result.day && result.day > 0)
            str.push(`${result.day}T`);
        if (result.hour && result.hour > 0)
            str.push(`${result.hour}h`);
        if (result.minute && result.minute > 0)
            str.push(`${result.minute}m`);
        if (options.showSeconds && result.second && result.second > 0)
            str.push(`${result.second}s`);
        if (str.length === 0)
            return "-";
        return str.join(" ");
    }
}
exports.humazineDuration = humazineDuration;
